<mat-dialog-content class="p-4 dark-bg  dark-mode">
    <h3 class="text-white" style="font-size: 22px;">
        <ng-container *ngIf="data && data.mode == 'new'">Add New</ng-container>
        <ng-container *ngIf="data && data.mode == 'edit'">Edit</ng-container>
        Certification
    </h3>
    <form [formGroup]="form">
        <div class="row mt-4">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Provider</mat-label>
                    <mat-select formControlName="provider" (selectionChange)="onProviderChange($event)">
                        <mat-option *ngFor="let provider of providers" [value]="provider.id">
                            {{ provider.providerName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Title</mat-label>
                    <mat-select formControlName="title">
                        <mat-option *ngFor="let title of titles" [value]="title.id">
                            {{ title.certificationTitle }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Attendance Type</mat-label>
                    <mat-select formControlName="attendanceType">
                        <mat-option *ngFor="let param of attendanceTypes.parameterMembers" [value]="param.parameterValue">
                            {{ param.parameterLabel }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Certification ID</mat-label>
                    <input type="text" matInput formControlName="certification">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Date Earned</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="dateEarned">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class=" dark-mode p-4 justify-content-end dark-bg">
    <button mat-raised-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="warn" (click)="resetForm()">Reset</button>
    <button mat-raised-button (click)="save()" *ngIf="!data.isAdmin" style="background:#5B25B4; color: #fff;">Save</button>
    <button mat-raised-button (click)="saveAdmin()" *ngIf="data.isAdmin" class="bg-accent-orange">Save</button>
</mat-dialog-actions>
